/** 缓存已经打印的日志字符串 */
export var logCache = {};
/** 获取某个播放器实例的日志缓存 */
export function getLogCache(instanceId) {
    return logCache[instanceId];
}
/** 清除某个播放器实例的日志缓存 */
export function clearLogCache(instanceId) {
    logCache[instanceId] = [];
}
export function mallocLogCache(instanceId) {
    if (!logCache[instanceId]) {
        logCache[instanceId] = [];
    }
}
export function appendLogCache(instanceId, payload) {
    var _a;
    (_a = logCache[instanceId]) === null || _a === void 0 ? void 0 : _a.push(payload);
}
